import { render } from "./VizualizationsCustom.vue?vue&type=template&id=318e2306&scoped=true&ts=true"
import script from "./VizualizationsCustom.vue?vue&type=script&lang=ts"
export * from "./VizualizationsCustom.vue?vue&type=script&lang=ts"

import "./VizualizationsCustom.vue?vue&type=style&index=0&id=318e2306&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-318e2306"]])

export default __exports__